"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStudentDetails = void 0;
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var api_1 = require("../../../../api");
var context_1 = require("../../../../api/context");
var useStudentDetails = function () {
    // --------------------------- Context
    var userService = (0, react_1.useContext)(context_1.ServiceContext).userService;
    // --------------------------- Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // --------------------------- Methods
    var fetchAllStudents = (0, react_1.useCallback)(function (sections) { return __awaiter(void 0, void 0, void 0, function () {
        var allStudents, _i, sections_1, section, sectionStudents;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    allStudents = [];
                    _i = 0, sections_1 = sections;
                    _a.label = 1;
                case 1:
                    if (!(_i < sections_1.length)) return [3 /*break*/, 4];
                    section = sections_1[_i];
                    return [4 /*yield*/, userService.findByClass(section.id)];
                case 2:
                    sectionStudents = _a.sent();
                    allStudents = allStudents.concat(sectionStudents);
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, allStudents];
            }
        });
    }); }, [userService]);
    var getTableHeaders = (0, react_1.useCallback)(function (assessmentTemplate) {
        var headers = [];
        var items = assessmentTemplate.items;
        items.forEach(function (item, itemIndex) {
            var questions = item.questions;
            if (questions.length === 1) {
                headers.push(t('studentsDetails.question', {
                    count: itemIndex + 1,
                }));
            }
            else {
                questions.forEach(function (question, questionIndex) {
                    headers.push("".concat(t('studentsDetails.question', {
                        count: itemIndex + 1,
                    })).concat((0, api_1.formatAnswerToLetter)(questionIndex).toUpperCase()));
                });
            }
        });
        return headers;
    }, [t]);
    return {
        fetchAllStudents: fetchAllStudents,
        getTableHeaders: getTableHeaders,
    };
};
exports.useStudentDetails = useStudentDetails;
